import { render, staticRenderFns } from "./DecisionDiamondCardMenu.vue?vue&type=template&id=c4b6a4c8&scoped=true"
import script from "./DecisionDiamondCardMenu.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondCardMenu.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondCardMenu.vue?vue&type=style&index=0&id=c4b6a4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b6a4c8",
  null
  
)

export default component.exports